import Crypto from 'crypto-js';


export const encrypt = (message) => Crypto.AES.encrypt(message, process.env.REACT_APP_SECRET_KEY).toString();

export const decrypt = (encrypted) => {
  const bytes  = Crypto.AES.decrypt(encrypted, process.env.REACT_APP_SECRET_KEY);
  return bytes.toString(Crypto.enc.Utf8);
}